import React, { useState } from 'react';
import TableWrap from '../../components/TableWrap';
import ButtonWrap from '../../components/ButtonWrap';
import SvgCsv from '../../components/svg/SvgCsv';
import ModalWrap from '../../components/ModalWrap';
import InputSearch from '../../components/InputSearch';
import Widget from '../../components/Widget';
import { TabsProps } from 'antd';
import DatePickerWrap from '../../components/DatePickerWrap';
import SelectWrap from '../../components/SelectWrap';
import InputWrap from '../../components/InputWrap';

const dataSource = [
  {
    key: '1',
    name: 'Mike',
    age: 32,
    address: '10 Downing Street',
  },
  {
    key: '2',
    name: 'John',
    age: 42,
    address: '10 Downing Street',
  },
];

const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Age',
    dataIndex: 'age',
    key: 'age',
  },
  {
    title: 'Address',
    dataIndex: 'address',
    key: 'address',
  },
];

const items: TabsProps['items'] = [
  {
    key: '1',
    label: 'Tab 1',
  },
  {
    key: '2',
    label: 'Tab 2',
  },
];

const CommonComponents = () => {
  const [openModal, setOpenModal] = useState<boolean>(false);

  return (
    <div style={{ marginBottom: 60, overflowX: 'hidden', padding: 24 }}>
      <h2>Table Wrap</h2>
      <TableWrap
        isPagination
        loading={false}
        onSearch={() => {}}
        tableProps={{
          dataSource,
          columns,
        }}
        rightTopContent={
          <>
            <ButtonWrap variant="outlined" width={158}>
              <SvgCsv /> 新規登録
            </ButtonWrap>
          </>
        }
      />

      <h2>Button Wrap</h2>
      <ButtonWrap variant="filled" color="primary" width={300}>
        Variant: filled - Color: primary
      </ButtonWrap>

      <ButtonWrap variant="outlined" color="danger" width={300}>
        <SvgCsv /> Variant: outlined - Color: danger
      </ButtonWrap>

      <ButtonWrap variant="filled" color="black" width={300}>
        <SvgCsv /> Variant: filled - Color: black
      </ButtonWrap>

      <ButtonWrap variant="filled" color="gray" width={300}>
        <SvgCsv /> Variant: filled - Color: gray
      </ButtonWrap>

      <h2>Modal Wrap</h2>
      <ButtonWrap variant="outlined" color="danger" width={300} onClick={() => setOpenModal(true)}>
        Click here to open sample modal
      </ButtonWrap>
      {openModal && (
        <ModalWrap
          open={openModal}
          cancelText="キャンセル"
          submitText="保存"
          onSubmit={() => {}}
          onCancel={() => setOpenModal(false)}
          type="upsert"
          title="会議室編集"
          body={<InputSearch width={330} />}
        />
      )}

      <h2>Widget</h2>
      <Widget
        breadcrumbs={['勤怠管理']}
        tabProps={{
          items,
          onChange: (key: string) => {},
        }}
        content={
          <TableWrap
            isPagination
            loading={false}
            onSearch={() => {}}
            tableProps={{
              dataSource,
              columns,
            }}
            rightTopContent={
              <>
                <ButtonWrap variant="outlined" width={158}>
                  <SvgCsv /> 新規登録
                </ButtonWrap>
              </>
            }
          />
        }
        title="勤怠管理"
      />

      <h2>DatePicker Wrap</h2>
      <DatePickerWrap width={312} />

      <h2>Select Wrap</h2>
      <SelectWrap width={312} />

      <h2>Input Wrap</h2>
      <InputWrap width={312} />
    </div>
  );
};

export default CommonComponents;
